"use client"
"use client";
import "../chunk-JSBRDJBE.js";

// src/client/ready-util.tsx
import { useEffect } from "react";
import { Fragment, jsx } from "react/jsx-runtime";
function ReadyUtil({ currentPath = "/" }) {
  function onResize() {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${vh}px`);
    const vw = document.documentElement.clientWidth * 0.01;
    document.documentElement.style.setProperty("--vw", `${vw}px`);
  }
  useEffect(() => {
    window.addEventListener("resize", onResize);
    onResize();
    return () => {
      window.removeEventListener("resize", onResize);
    };
  }, []);
  useEffect(() => {
    const isHome = currentPath === "/";
    const hasScrolled = window.scrollY > 0;
    const delay = hasScrolled ? 0 : 1e3 * Number.parseFloat(
      getComputedStyle(document.body).getPropertyValue("--is-ready-delay")
    );
    if (isHome && hasScrolled) {
      document.body.classList.add("home-scrolled");
    }
    const timeout = setTimeout(() => {
      if (isHome) {
        document.body.classList.add("home-ready");
      }
      document.body.classList.add("ready");
    }, delay);
    return () => {
      clearTimeout(timeout);
      document.body.classList.remove("home-scrolled");
      document.body.classList.remove("home-ready");
      document.body.classList.remove("ready");
    };
  }, [currentPath]);
  return /* @__PURE__ */ jsx(Fragment, {});
}
export {
  ReadyUtil as default
};
